import React, { useState } from "react";
import {
  Typography,
  Button,
  Box,
  Modal,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import AccessibleIconButton from "components/base/AccessibleIconButton";

const ArchivePopup = ({
  archivePopup,
  setArchivePopup,
  collection,
  handleArchiveCollection,
}) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const handleArchive = async () => {
    setLoading(true);
    try {
      await handleArchiveCollection(collection.collectionId, true);
      setArchivePopup(false);
      if (
        pathname.includes(`/collections/${collection.collectionId}`) &&
        !pathname.includes("/collections/archive/")
      ) {
        navigate(pathname.replace("/collections/", "/collections/archive/"));
      }
    } catch (error) {
      toast.error("Failed to archive collection");
    } finally {
      setLoading(false);
    }
  };

  const onClose = () => {
    setArchivePopup(false);
  };

  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: { xs: "100vw", sm: "50vw", md: "35vw" },
    bgcolor: "background.paper",
    boxShadow: 0,
    borderRadius: 2,
  };

  return (
    <Modal
      open={archivePopup}
      onClose={onClose}
      slotProps={{
        backdrop: {
          style: { backgroundColor: "rgba(0, 0, 0, 0.2)" },
        },
      }}
    >
      <Box sx={modalStyle}>
        <Box sx={{ p: 4 }}>
          <Typography
            variant="h4"
            component="div"
            color="#406da4"
            fontWeight="600"
          >
            Confirm Archive
          </Typography>
          <AccessibleIconButton
            title="Close"
            onClick={onClose}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </AccessibleIconButton>

          <Typography variant="body1" mt={1}>
            Are you sure you want to archive this collection? It will become
            read-only until it is unarchived.
          </Typography>
          {collection?.isShared_ysn && (
            <Typography variant="body1" mt={2} color="error">
              This collection is shared. Archiving it will archive it for all
              users it is shared with.
            </Typography>
          )}
        </Box>
        <Box
          sx={{
            backgroundColor: "secondary.main",
            display: "flex",
            justifyContent: "space-between",
            gap: 5,
            px: 5,
            py: 3,
            borderRadius: "0 0 20px 20px",
          }}
        >
          <Button
            onClick={onClose}
            variant="outlined"
            sx={{ width: "45%" }}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button
            onClick={handleArchive}
            disabled={loading}
            sx={{
              width: "45%",
              display: "flex",
              gap: 1,
            }}
          >
            {loading && <CircularProgress size={20} />}
            Archive
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ArchivePopup;
